import {Component, OnInit, inject, ChangeDetectionStrategy} from '@angular/core';
import {Router} from "@angular/router";
import { HttpClient, HttpContext } from "@angular/common/http";
import {NGX_LOADING_BAR_IGNORED} from "@ngx-loading-bar/http-client";
import {User} from "../../../../../authentication/models/user";
import { LoaderComponent } from '../../../loader/loader.component';


@Component({
    selector: 'app-waiting-page',
    templateUrl: './waiting-page.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoaderComponent]
})
export class WaitingPageComponent implements OnInit {
  private _router = inject(Router);
  private _httpClient = inject(HttpClient);


  timeLeft: number = 15;
  interval;

  ngOnInit(): void {
    this.startTimer();
    this._httpClient.get<any>('api/users/me/', {context: new HttpContext().set(NGX_LOADING_BAR_IGNORED, true)}).subscribe((res: User) => {
      if (res) {
        this._router.navigate(['admin'])
      }
    })
  }

  startTimer() {
    this.clearTimer();
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.timeLeft = 15
      }
    }, 1000)
  }

  clearTimer() {
    clearInterval(this.interval);
  }

}
